import React from 'react';
import T from 'prop-types';
import cx from 'classnames';

const Checkbox = ({
  disabled,
  checked,
  id,
  highlighted,
  indeterminate,
  checkboxClassName = '',
  backgroundColor,
  circle,
  size,
  withHoverEffect,
  onChange = () => {},
}) => {
  const handleChange = (e) => {
    if (disabled) return;
    onChange(e.target.checked);
  };
  return (
    <input
      type="checkbox"
      className={cx(
        'checkbox-input',
        { 'with-hover-effect': withHoverEffect },
        { highlighted },
        { indeterminate },
        { circle },
        { disabled },
        size,
        checkboxClassName
      )}
      id={id}
      style={{ backgroundColor: checked && backgroundColor }}
      checked={checked}
      disabled={disabled}
      onChange={handleChange}
    />
  );
};

Checkbox.propTypes = {
  id: T.oneOfType([T.string, T.number]),
  checked: T.bool,
  size: T.string,
  withHoverEffect: T.bool,
  disabled: T.bool,
  highlighted: T.bool,
  circle: T.bool,
  backgroundColor: T.string,
  indeterminate: T.bool,
  checkboxClassName: T.oneOfType([T.string, T.func]),
  onChange: T.func,
};
export default Checkbox;
